module.exports = __webpack_public_path__ + "static/media/gemch_shoes.c5cfe541.jpg";